import { useEffect, useState } from 'react'
import useToastMessage from '../../../../hooks/use-toast-message'
import useUser from '../../../../hooks/use-user'
import { isCouncilUserOrAdmin, isDriller } from '../../../../services/user-utils'
import { useWellState } from '../../../../context/well-context'
import { useLocation } from 'react-router-dom'
import { Heading, RecordContent } from '@msaf/core-react'

interface ApprovalState {
  submitted: boolean
}

export default function NewWellApprove() {
  const { user } = useUser()
  const location = useLocation() as { state: ApprovalState }
  const [isPublished, setIsPublished] = useState<boolean | undefined>(false)
  const [isUnderReview, setIsUnderReview] = useState<boolean | undefined>(false)
  const [isFromSubmissionPage, setIsFromSubmissionPage] = useState<boolean | undefined>(false)
  const { wellState } = useWellState()

  useToastMessage({
    successMessage: isPublished ? 'Record has been published' : 'Record has been submitted',
    isSuccess: (isPublished || isUnderReview) && isFromSubmissionPage,
  })

  useEffect(() => {
    setIsPublished(wellState.isPublished)
    setIsUnderReview(wellState.isUnderReview)
    setIsFromSubmissionPage(location?.state?.submitted)
  }, [wellState.isPublished, wellState.isUnderReview, location?.state?.submitted])

  return (
    <RecordContent>
      {isPublished ? (
        <>
          <Heading level={2}>Well published</Heading>
          <p>This well has now been published and is available as public record.</p>
        </>
      ) : (
        <>
          <Heading level={2}>Well information under review</Heading>
          {isDriller(user) && (
            <p>
              The well information has been submitted to council for assessment. You may be contacted for further
              information or clarification if needed, otherwise the submitted well will be published following review.
            </p>
          )}
          {isCouncilUserOrAdmin(user) && (
            <p>
              The well information provided has been submitted for review. You may be contacted for further information
              or clarification.
            </p>
          )}
        </>
      )}
    </RecordContent>
  )
}
